import * as components from './components';

export default [
  {
    path: '/masters/canadian-taxes',
    component: components.CanadianTaxList,
    name: 'canadianTaxList',
    meta: { admin: true }
  }
];


// WEBPACK FOOTER //
// ./ClientApp/app/masters/canadiantaxes/routes.js